import { h } from '@/lib/dom';

export interface DrawerOptions {
  content: Node | ((close: () => void) => Node);
  title?: string;
}

export function openDrawer(opts: DrawerOptions): { close: () => void } {
  const backdrop = h('div', {
    class: 'drawer-backdrop',
    on: {
      click: (ev) => {
        if (ev.target === backdrop) close();
      },
    },
  });
  const drawer = h('nav', {
    class: 'drawer',
    role: 'dialog',
    aria: { modal: 'true', label: opts.title ?? 'Навигация' },
    tabindex: '-1',
  });
  const content = typeof opts.content === 'function' ? opts.content(() => close()) : opts.content;
  drawer.appendChild(content);
  document.body.append(backdrop, drawer);
  // Restore focus to the trigger (e.g. the navbar hamburger) on close, matching
  // Modal — otherwise keyboard/SR users land on <body> and tab from the top.
  const previouslyFocused = document.activeElement as HTMLElement | null;
  drawer.focus();

  function onKey(ev: KeyboardEvent): void {
    if (ev.key === 'Escape') close();
  }
  document.addEventListener('keydown', onKey);

  function close(): void {
    document.removeEventListener('keydown', onKey);
    backdrop.remove();
    drawer.remove();
    previouslyFocused?.focus();
  }
  return { close };
}
